import { defineStore } from 'pinia'
import { useRoute } from 'vue-router'
import { ref, computed, Ref } from 'vue'
import { getCookie } from '@/utils/cookies'
import { networkListResource } from '@services/network.service'
import { SELECTED_MEDICAL_CHAIN_COOKIE_NAME } from '@/const'
import { useCookies } from '@vueuse/integrations/useCookies'
import { CHAIN_CREATE_VIEW_NAME } from './router'

const id = 'medicalChainStore'

interface MedicalChain {
  title: Record<string, string>
  id: string
  languagesDefault: string
  languagesAvailable: string[]
}

export const useMedicalChainStore = defineStore(id, () => {
  const chainList = ref<MedicalChain[]>([])
  const chainLoading = ref(true)
  const cookies = useCookies([SELECTED_MEDICAL_CHAIN_COOKIE_NAME])

  const route = useRoute()
  
  const currentMedicalChainId = computed(() =>{
    if (route.name === CHAIN_CREATE_VIEW_NAME) {
      return null
    }
    return cookies.get(SELECTED_MEDICAL_CHAIN_COOKIE_NAME)
  })
  const medicalChain = computed<MedicalChain>(() => {
    return (
      chainList.value.find(
        (chain) => chain.id === currentMedicalChainId.value
      )
    )
  })

  const languagesDefault = computed(() => medicalChain.value?.languagesDefault || null)
  const languagesAvailable = computed(() => medicalChain.value?.languagesAvailable || [])

  function getChains() {
    chainLoading.value = true
    networkListResource
      .execute()
      .then(({ items }: { items: MedicalChain[] }) => {
        chainList.value = items
      })
      .finally(() => {
        chainLoading.value = false
      })
  }
  return {
    medicalChain,
    languagesDefault,
    languagesAvailable,
    chainLoading,
    chainList,
    getChains,
    currentMedicalChainId,
  }
})
